import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDown = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" ref={ref} {...props}><path fill="#32325D" d="M10.273 4.94L9.333 4 5.333 8 9.333 12 10.273 11.06 7.22 8z" transform="rotate(-90 7.803 8)" /></svg>;
const ForwardRef = forwardRef(SvgArrowDown);
export { ForwardRef as ReactComponent };
import __svgUrl from "/home/jenkins/agent/workspace/_Connect_service_dev_uat-release/src/images/arrow-down.svg?url";
export default __svgUrl;
